import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form4797Service {

  constructor(private http: HttpClient) {}

  /**
   * Load Form 4797 data via loadPivotFormJson.
   * Original action_id: 438
   */
  loadFormData(baseUrl: string, params: Record<string, any>): Observable<any> {
    const url = `${baseUrl}/loadPivotFormJson`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    return this.http.get<any>(`${url}?${urlEncoded.toString()}`, { withCredentials: true });
  }

  /**
   * Save Form 4797 data via saveJsonObject.
   * Original action_code: jqzx4y
   */
  saveFormData(
    baseUrl: string,
    formData: any[],
    jsonSettings: any,
    globalParams: Record<string, any> = {},
    filterParams: Record<string, any> = {},
    processName: string = 'Form 4797 Save'
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=jqzx4y`;

    let params: any = _.merge({}, globalParams, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(formData) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = processName;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
